define('app/filters/SegmentView',['require','glu/itemView','./CompactFieldFilterView','./SegmentMenuView','glu/util','hbs!./SegmentView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		CompactFieldFilterView = require('./CompactFieldFilterView'),
		SegmentMenuView = require('./SegmentMenuView'),
		_ = require('glu/util');

	var SegmentView = ItemView.extend({
		template: require('hbs!./SegmentView.hbs'),

		events: {
			'click .delete button': 'removeSegment',
			'click .column-type-menu': 'toggleMenu',
			'mouseleave': 'closeMenu',
			'click .show-filters': 'toggleSegment',
			'click .hide-filters': 'toggleSegment'
		},

		initialize: function() {
			this.listenTo(this.model, 'removeSegment', this.removeSegment);
		},

		toggleMenu: function(e) {
			e.preventDefault();
			e.stopPropagation();

			this.$el.find('.column-type-menu').toggleClass('active');
		},

		closeMenu: function() {
			this.$el.find('.column-type-menu').removeClass('active');
		},

		generateMenu: function() {
			var view = new SegmentMenuView({
				model: this.model,
				report: this.options.report
			});

			view.render();

			this.$el.find('.column-type-menu .menu').append(view.render().el);
		},

		segmentName: function() {
			return this.model.get('name');
		},

		serializeData: function() {
			return this;
		},

		onRender: function() {
			var self = this;

			self.prevNumFilters = self.numFilters;
			self.numFilters = self.model.get('filters').length;

			self.addFilters();
			self.generateMenu();

			// Hide filter list by default
			this.$el.find('> ul').hide();

			// Expand the segment if in segment view
			if (this.options.report.get('segmentId')) {
				this.toggleSegment();
			}
		},

		addFilters: function() {
			var self = this,
				filtersList = this.$el.find('.segment-compound-filters-list'),
				domain = self.options.report.get('domain'),
				segmentFilter = domain.buildFilter(this.model.get('filters'));

			segmentFilter.filterCollection().each(function(filter) {
				filter.set('segmentId', self.model.get('id'));
				var FilterView = CompactFieldFilterView;
				var view = new FilterView({
					model: filter,
					report: self.options.report,
					tagName: 'li',
					className: 'form-group filter-compact'
				});

				view.render();
				filtersList.append(view.render().$el);
			});
		},

		removeSegment: function() {
			var self = this;
			var segmentFilters = _.filter(self.options.report.get('filter').get('filterCollection').models, function(filter) {
				return filter.get('segmentId') === self.model.get('id');
			});
			for (var i = 0; i < segmentFilters.length; i++) {
				self.options.report.get('filter').get('filterCollection').remove(segmentFilters[i]);
			}
			this.appBus.trigger('refresh');
		},

		toggleSegment: function(e) {
			if (e) {
				e.preventDefault();
			}

			this.$el.find('> ul').toggle();
			this.$el.find('.show-filters').toggleClass('hidden');
			this.$el.find('.hide-filters').toggleClass('hidden');
			this.appBus.trigger('report:viewport:change');
		}
	});

	return SegmentView;

});

